import { Component, Input } from '@angular/core';
import { InformativeStatus } from './informative-status.types';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-informative-status',
  templateUrl: './informative-status.component.html',
  styleUrl: './informative-status.component.scss',
  imports: [CommonModule, ButtonModule, TranslateModule],
})
export class InformativeStatusComponent {
  @Input() informativeStatus?: InformativeStatus = {
    iconProps: { icon: '', class: '' },
    title: '',
    subtitle: '',
    actionButton: {
      label: '',
      onClick: () => {
        console.warn('No action button defined');
      },
    },
  };
}
